var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"aside-menu"})
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Aside.vue?vue&type=template&id=441e579c&
// module id = null
// module chunks = 